import { Sidebar } from './Sidebar';
import { Header } from './Header';

export const Layout = ({ children, title, subtitle }) => {
  return (
    <div className="flex h-screen bg-slate-50" data-testid="app-layout">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={title} subtitle={subtitle} />
        <main className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
};
